import { IsInt, IsString, IsOptional, Min, IsEnum } from "class-validator";
import { InstallLocation } from "./install-location.enum";
import { Expose } from "class-transformer";

export class UpsertWishlistProjectElementDto {
  @Expose()
  @IsOptional()
  @IsInt()
  selectedPriceLow?: number;

  @Expose()
  @IsOptional()
  @IsInt()
  selectedPriceHigh?: number;

  @Expose()
  @IsOptional()
  @IsEnum(InstallLocation, { each: true })
  installLocation?: InstallLocation[];

  @Expose()
  @IsOptional()
  @IsString()
  notes?: string;

  @Expose()
  @IsOptional()
  @IsInt()
  @Min(0)
  priority?: number;
}
